import Color from 'color';

export const primaryColor = Color.rgb(20, 110, 232);

// Selection
export const activeSelectionColor = Color.rgb(118, 167, 250, 0.25);
export const inactiveSelectionColor = Color.rgb(0, 0, 0, 0.1);
export const remoteSelectionOpacity = 0.25;

// Comment
export const inactiveCommentColor = Color.rgb(249, 203, 64, 0.2);
export const activeCommentColor = Color.rgb(253, 237, 188);

// Search hit
export const inactiveSearchHitColor = Color.rgb(249, 203, 64, 0.2);
export const activeSearchHitColor = Color.rgb(253, 237, 188);

// Input field
export const defaultInputFieldBackgroundColor = new Color('#F4F5F5');
export const activeInputFieldBackgroundColor = primaryColor.alpha(0.1);
export const inputFieldBorderColor = primaryColor;

// Matches MUI `palette.text.disabled` — unchecked options at max selection.
export const disabledCheckboxColor = Color.rgb(0, 0, 0, 0.38);

// Instruction field
export const activeInstructionFieldBackgroundColor = new Color('#F4F5F5');

// Table of Contents
export const activeTableOfContentsOutlineColor = primaryColor;

// Page break
export const pageBreakColor = primaryColor;

// Non-printing characters (formatting marks like ¶)
export const nonPrintingCharacterColor = primaryColor;

// Dynamic block
export const inactiveDynamicBlockColor = Color.rgb(209, 209, 209);

// Table (default colors used by Word)
export const insertTableCellColor = new Color('#E1F2FA');
export const removeTableCellColor = new Color('#FCE6F4');

/**
 * Backgrounds behind AI-suggested edits. They live here, with the rest of the
 * palette, rather than in `util/presence-color` which re-exports them: that
 * module pulls in `../slate-api` and `../rendering`, so consumers needing only
 * the literal — the MUI theme, and through it the standalone Teams
 * channel-interaction page — would drag that whole graph in.
 */
export const AI_INSERT_HIGHLIGHT_COLOR = '#D0E0FF';
export const AI_DELETE_HIGHLIGHT_COLOR = '#FFD0D0';
